// extracted by mini-css-extract-plugin
export default {"market_block":"styles_market_block__T5NmH"};